export default __webpack_public_path__ + "banner-bg51a690.jpg";